import React, { useEffect } from "react";
// Custom Fields Modal

// Default
import { useState } from "react";

// Mui
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import Stack from "@mui/material/Stack";

// Custom
import ContainedButton from "../../forms/button/ContainedButton";
import CustomInput from "../../forms/input/Input";

// Utils
import { LiveDataRecord, ToastState } from "../../types";
import { fetchGETRequest, fetchPOSTRequest } from "../../utils/services";
import CustomToast from "../toast/CustomToast";
import { Grid2 as Grid } from "@mui/material";

type ReadValueState = {
  MeterSerialNumber: string;
  IP_MeterTime: string;
  IP_Current: string;
  IP_Voltage: string;
  IP_Frequency: string;
  IP_NeutralCurrent: string;
  IP_PowerFactor: string;
  IP_KW: string;
  IP_KVA: string;
  IP_KWH: string;
  IP_KWHEXP: string;
  IP_KVAH: string;
  IP_KVAHEXP: string;
  IP_MDKW: string;
  IP_MDKVA: string;
  IP_MDResetCount: string;
  IP_ProgramCount: string;
  IP_TamperCount: string;
  IP_TotalPowerOnDuration: string;
  IP_RelayStatus: string;
  IP_LoadLimitValue: string;
  Project_ID: string;
};

const InitialState: ReadValueState = {
  MeterSerialNumber: "",
  IP_MeterTime: "",
  IP_Current: "",
  IP_Voltage: "",
  IP_Frequency: "",
  IP_NeutralCurrent: "",
  IP_PowerFactor: "",
  IP_KW: "",
  IP_KVA: "",
  IP_KWH: "",
  IP_KWHEXP: "",
  IP_KVAH: "",
  IP_KVAHEXP: "",
  IP_MDKW: "",
  IP_MDKVA: "",
  IP_MDResetCount: "",
  IP_ProgramCount: "",
  IP_TamperCount: "",
  IP_TotalPowerOnDuration: "",
  IP_RelayStatus: "",
  IP_LoadLimitValue: "",
  Project_ID: "",
};

const ReadValueFileds: { label: string; keyValue: keyof ReadValueState }[] = [
  //   { label: "Meter Serial Number", keyValue: "MeterSerialNumber" },
  //   { label: "IP Meter Time", keyValue: "IP_MeterTime" },
  { label: "IP Current", keyValue: "IP_Current" },
  { label: "IP Voltage", keyValue: "IP_Voltage" },
  { label: "IP Frequency", keyValue: "IP_Frequency" },
  { label: "IP Neutral Current", keyValue: "IP_NeutralCurrent" },
  { label: "IP Power Factor", keyValue: "IP_PowerFactor" },
  { label: "IP KW", keyValue: "IP_KW" },
  { label: "IP KVA", keyValue: "IP_KVA" },
  { label: "IP KWH", keyValue: "IP_KWH" },
  { label: "IP KWHEXP", keyValue: "IP_KWHEXP" },
  { label: "IP KVAH", keyValue: "IP_KVAH" },
  { label: "IP KVAHEXP", keyValue: "IP_KVAHEXP" },
  { label: "IP MDKW", keyValue: "IP_MDKW" },
  { label: "IP MDKVA", keyValue: "IP_MDKVA" },
  { label: "IP MDResetCount", keyValue: "IP_MDResetCount" },
  { label: "IP ProgramCount", keyValue: "IP_ProgramCount" },
  { label: "IP TamperCount", keyValue: "IP_TamperCount" },
  { label: "IP TotalPowerOnDuration", keyValue: "IP_TotalPowerOnDuration" },
  { label: "IP RelayStatus", keyValue: "IP_RelayStatus" },
  { label: "IP LoadLimitValue", keyValue: "IP_LoadLimitValue" },
  //   { label: "Project_ID", keyValue: "Project_ID" },
];

type TimeSeriesEntry = {
  ts: number; // timestamp (probably Unix epoch format)
  value: string; // value as string, might need parsing to number
};

interface MeterData {
  MeterSerialNumber: TimeSeriesEntry[];
  IP_MeterTime: TimeSeriesEntry[];
  IP_Current: TimeSeriesEntry[];
  IP_Voltage: TimeSeriesEntry[];
  IP_Frequency: TimeSeriesEntry[];
  IP_NeutralCurrent: TimeSeriesEntry[];
  IP_PowerFactor: TimeSeriesEntry[];
  IP_KW: TimeSeriesEntry[];
  IP_KVA: TimeSeriesEntry[];
  IP_KWH: TimeSeriesEntry[];
  IP_KWHEXP: TimeSeriesEntry[];
  IP_KVAH: TimeSeriesEntry[];
  IP_KVAHEXP: TimeSeriesEntry[];
  IP_MDKW: TimeSeriesEntry[];
  IP_MDKVA: TimeSeriesEntry[];
  IP_MDResetCount: TimeSeriesEntry[];
  IP_ProgramCount: TimeSeriesEntry[];
  IP_TamperCount: TimeSeriesEntry[];
  IP_TotalPowerOnDuration: TimeSeriesEntry[];
  IP_RelayStatus: TimeSeriesEntry[];
  IP_LoadLimitValue: TimeSeriesEntry[];
  Project_ID: TimeSeriesEntry[];
  LS_MeterTime: TimeSeriesEntry[];
  LS_AvgCurrent: TimeSeriesEntry[];
  LS_AvgVoltage: TimeSeriesEntry[];
  LS_Frequency: TimeSeriesEntry[];
  LS_PF: TimeSeriesEntry[];
  LS_KW: TimeSeriesEntry[];
  LS_KVA: TimeSeriesEntry[];
  LS_KWH: TimeSeriesEntry[];
  LS_KWH_EXP: TimeSeriesEntry[];
  LS_KVAH: TimeSeriesEntry[];
  LS_KVAH_EXP: TimeSeriesEntry[];
  EventDate: TimeSeriesEntry[];
  EventCode: TimeSeriesEntry[];
  EventDescription: TimeSeriesEntry[];
}

const UpdateReadValueModel = ({
  meterId,
  readValue,
  onClose,
  onSuccess,
}: {
  meterId: string;
  readValue: LiveDataRecord;
  onClose: () => void;
  onSuccess: () => void;
}) => {
  const [toast, setToast] = useState<ToastState>({
    message: "",
    severity: "",
  });

  const [updateLoader, setUpdateLoader] = useState<boolean>(false);

  const [readValueState, setReadValueState] =
    useState<ReadValueState>(InitialState);

  const handleUpdate = async () => {
    setUpdateLoader(true);

    const newData = {
      Status: true,
      ApiName: "",
      BatchId: "",
      ProjectName: "",
      Data: {
        Command: "EditInstantaneousProfile",
        Parameters: {
          SerialNumber: meterId,
          Value: [readValueState],
        },
      },
      Error: [],
    };

    console.log(newData, "---updated newData---");

    try {
      await fetchPOSTRequest(`hes/response`, newData);
      setToast({
        message: "Read value updated successfully",
        severity: "success",
      });
      onSuccess();
    } catch (error) {
      console.log(error, "---error---");
      setToast({
        message: "Failed to update read value",
        severity: "error",
      });
    }

    setUpdateLoader(false);
  };

  const fetchReadValue = async () => {
    try {
      const responseKeys = await fetchGETRequest<string[]>(
        `plugins/telemetry/DEVICE/${meterId}/keys/timeseries`
      );

      const csvKeys = responseKeys?.join(",");

      const response = await fetchGETRequest<MeterData>(
        `plugins/telemetry/DEVICE/${meterId}/values/timeseries?keys=${csvKeys}&startTs=${readValue?.ts}&endTs=${Number(readValue?.ts) + 1}`
      );
      const data: MeterData = response;

      const newData: ReadValueState = {
        MeterSerialNumber: data?.MeterSerialNumber[0]?.value,
        IP_MeterTime: data?.IP_MeterTime[0]?.value,
        IP_Current: data?.IP_Current[0]?.value,
        IP_Voltage: data?.IP_Voltage[0]?.value,
        IP_Frequency: data?.IP_Frequency[0]?.value,
        IP_NeutralCurrent: data?.IP_NeutralCurrent[0]?.value,
        IP_PowerFactor: data?.IP_PowerFactor[0]?.value,
        IP_KW: data?.IP_KW[0]?.value,
        IP_KVA: data?.IP_KVA[0]?.value,
        IP_KWH: data?.IP_KWH[0]?.value,
        IP_KWHEXP: data?.IP_KWHEXP[0]?.value,
        IP_KVAH: data?.IP_KVAH[0]?.value,
        IP_KVAHEXP: data?.IP_KVAHEXP[0]?.value,
        IP_MDKW: data?.IP_MDKW[0]?.value,
        IP_MDKVA: data?.IP_MDKVA[0]?.value,
        IP_MDResetCount: data?.IP_MDResetCount[0]?.value,
        IP_ProgramCount: data?.IP_ProgramCount[0]?.value,
        IP_TamperCount: data?.IP_TamperCount[0]?.value,
        IP_TotalPowerOnDuration: data?.IP_TotalPowerOnDuration[0]?.value,
        IP_RelayStatus: data?.IP_RelayStatus[0]?.value,
        IP_LoadLimitValue: data?.IP_LoadLimitValue[0]?.value,
        Project_ID: data?.Project_ID[0]?.value,
      };

      setReadValueState(newData);
    } catch (error) {
      console.log(error, "---error---");
      setToast({
        message: "Failed to fetch read value",
        severity: "error",
      });
    }
  };

  useEffect(() => {
    fetchReadValue();
  }, [readValue, meterId]);

  const updateStateValue = (key: keyof ReadValueState, value: string) => {
    setReadValueState({ ...readValueState, [key]: value });
  };

  return (
    <Dialog
      onClose={onClose}
      open={true}
      maxWidth={false}
      sx={{
        "& .MuiPaper-root": {
          width: "800px",
          maxWidth: "none",
        },
      }}
    >
      <Stack
        direction={"row"}
        justifyContent={"space-between"}
        alignItems={"center"}
      >
        {/* <IconButton
          sx={{ marginLeft: "10px" }}
          onClick={() => {
            toggleCustomFieldModal();
            toggleCustomFieldDrawer(fieldsDrawer?.type, true);
          }}>
          <UnifiedIcon icon={FaAngleLeft} color="#0000008a" fontSize="20px" />
        </IconButton> */}

        <DialogTitle>Update Read Value</DialogTitle>
        <IconButton onClick={onClose} sx={{ marginRight: "10px" }}>
          <CloseIcon />
        </IconButton>
      </Stack>

      <DialogContent dividers>
        <Stack direction={"column"} gap={"20px"}>
          <Grid container spacing={2}>
            {ReadValueFileds.map((item) => (
              <Grid
                key={item.keyValue}
                size={{ xs: 12, md: 6, lg: 6, sm: 6, xl: 6 }}
              >
                <CustomInput
                  label={item.label}
                  placeholder={"Add a title..."}
                  value={readValueState[item.keyValue]}
                  onChange={(e) =>
                    updateStateValue(item.keyValue, e.target.value)
                  }
                />
              </Grid>
            ))}
          </Grid>

          <ContainedButton
            label={"Update"}
            sx={{
              width: "100%",
              fontWeight: 600,
              color: "#ffffff",
            }}
            disabled={updateLoader}
            onClick={handleUpdate}
          />
        </Stack>
      </DialogContent>
      <CustomToast
        severity={toast?.severity}
        open={toast?.message}
        setToast={setToast}
      />
    </Dialog>
  );
};

export default UpdateReadValueModel;
